import React from "react";
import { CHANNEL_PARTNER_DISCLOSURE } from "../../constants/businessInfo";

const normalizeName = (value = "") => value.toLowerCase().replace(/\s+/g, " ").trim();

const ChannelPartnerDisclosure = ({
  developerName,
  companyName = "Thakkhar Realtors",
  forceShow = false,
  className = "",
}) => {
  const shouldShow =
    forceShow ||
    (developerName && normalizeName(developerName) !== normalizeName(companyName));

  if (!shouldShow) return null;

  return (
    <aside
      className={`rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 ${className}`}
      aria-label="Channel Partner Disclosure"
    >
      {CHANNEL_PARTNER_DISCLOSURE}
    </aside>
  );
};

export default ChannelPartnerDisclosure;
